
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 128 128"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M59 12.7v45.8h9.9V12.7c0-3.1 2.5-5.7 5.5-5.7s5.5 2.6 5.5 5.7v45.8h9.9V12.7c0-3.1 2.5-5.7 5.5-5.7s5.5 2.6 5.5 5.7v45.8h14.4c3.2 0 5.7 2.4 5.7 5.5 0 3-2.6 5.5-5.7 5.5h-14.4v45.8c0 3.1-2.5 5.7-5.5 5.7s-5.5-2.6-5.5-5.7V69.5h-9.9v45.8c0 3.1-2.5 5.7-5.5 5.7s-5.5-2.6-5.5-5.7V69.5H59v45.8c0 3.1-2.5 5.7-5.5 5.7s-5.5-2.6-5.5-5.7V69.5h-9.9v45.8c0 3.1-2.5 5.7-5.5 5.7s-5.5-2.6-5.5-5.7V69.5H12.7C9.5 69.5 7 67 7 64s2.5-5.5 5.7-5.5h14.4V12.7c0-3.1 2.5-5.7 5.5-5.7s5.5 2.6 5.5 5.7v45.8h10V12.7c0-3.1 2.5-5.7 5.5-5.7S59 9.6 59 12.7"}})])
          )
        }
      }
    